import { useGetSettings } from '@ipfabric/api-client/client/model/settings/settings';
import { allowLeave } from '@ipfabric/ui-components/LeaveDialog/LeaveDialog';
import {
  disableStartBtn,
  enableStartBtn,
} from 'pages/SnapshotManagement/actions';
import { PAGE_URL as SNAPSHOT_SETTINGS_PAGE } from 'pages/SnapshotManagement/constants';
import type { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from 'utils/hooks/useNotifications';
import { renderQuery } from 'utils/react-query/renderQuery';
import { useApi } from 'utils/request/useApi';
import { DiscoverySettings } from '../composition/DiscoverySettings/DiscoverySettings';
import { handleDiscoveryError } from '../utils/handleDiscoveryError';
import { pickDiscoverySettingsFromGlobalSettings } from '../utils/pickDiscoverySettingsFromGlobalSettings';

interface Props {
  onClose: () => void;
  saveButtonDisabled: boolean;
}

export const NewSnapshotPage: FC<Props> = (props) => {
  const globalSettingsQuery = useGetSettings();
  const api = useApi();
  const notifications = useNotifications();
  const reduxDispatch = useDispatch();
  const navigate = useNavigate();

  return renderQuery({
    query: globalSettingsQuery,
    renderStaleDataOnMount: false,
    success: (data) => (
      <DiscoverySettings
        initialModel={pickDiscoverySettingsFromGlobalSettings(data)}
        newSnapshot
        onBackButtonClick={props.onClose}
        onSubmit={async (discoverySettingsObject) => {
          try {
            reduxDispatch(disableStartBtn());
            await api.request({
              url: '/snapshots',
              method: 'POST',
              data: discoverySettingsObject,
            });
            allowLeave(() => {
              navigate(`${SNAPSHOT_SETTINGS_PAGE}/new`);
            });
          } catch (e: unknown) {
            // This one is currently controlled by socket events not to enable start button too early.
            // So it's "correct" to have it in `catch` branch instead of `finally`.
            reduxDispatch(enableStartBtn());
            handleDiscoveryError({
              error: e,
              showNotification: notifications.showNotification,
            });
          }
        }}
        pageTitle='New snapshot'
        saveButtonDisabled={props.saveButtonDisabled}
        saveButtonLabel='Run discovery'
        saveButtonIcon='fa-play'
        showUpdateFromGlobalSettingsButton={false}
        snapshotId={null}
      />
    ),
  });
};
